export default __webpack_public_path__ + "dbcb17a45c1e446a7667211759bf3705.png";